export default __webpack_public_path__ + "95f1ba2e66c40cc0d6723aba48a93a9a.png";